import { useState, useCallback } from 'react';
import { getPtoConflict } from 'helpers/userUpdate';

const CONFIRM_SUFFIX = 'Please, confirm to proceed.';

const withConfirmSuffix = (message) => {
  if (!message) return message;
  return message.includes(CONFIRM_SUFFIX) ? message : `${message}\n${CONFIRM_SUFFIX}`;
};

export default () => {
  const [pending, setPending] = useState(null);

  const requestConfirm = useCallback((message, retry) => {
    setPending({ message, retry });
  }, []);

  const cancel = useCallback(() => setPending(null), []);

  const confirm = useCallback(async () => {
    if (!pending) return;
    const { retry } = pending;
    setPending(null);
    await retry();
  }, [pending]);

  const handleError = useCallback(
    (error, retry) => {
      const conflict = getPtoConflict(error);
      if (conflict) {
        requestConfirm(conflict.message, retry);
        return true;
      }
      return false;
    },
    [requestConfirm]
  );

  return {
    isOpen: Boolean(pending),
    message: withConfirmSuffix(pending?.message || ''),
    handleError,
    confirm,
    cancel,
  };
};
